import ApiService from "../ApiService";
const { REACT_APP_REST_ENDPOINT } = process.env;
const REND_ENDPOINT = `${REACT_APP_REST_ENDPOINT}/rendicontazione`;

const RendicontazioneService = {
    // --- FUNZIONI PARTNER ---
    getReportMensile(data) {
        const url = `${REND_ENDPOINT}/report-mensile`;
        return new Promise((resolve, reject) => {
            ApiService.postRequest(resolve, reject, url, data);
        });
    },

    getStorico(data) {
        const url = `${REND_ENDPOINT}/storico`;
        return new Promise((resolve, reject) => {
            ApiService.postRequest(resolve, reject, url, data);
        });
    },
    
    uploadFattura(formData) {
        const url = `${REND_ENDPOINT}/upload-fattura`;
        const token = localStorage.getItem("token");

        return new Promise((resolve, reject) => {
            fetch(url, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`
                },
                body: formData
            })
            .then(response => {
                if (response.ok) {
                    resolve(response.json());
                } else {
                    response.json().then(err => reject(err)).catch(() => reject(response));
                }
            })
            .catch(error => {
                reject(error);
            });
        });
    },

    // --- FUNZIONI SUPERPARTNER ---
    getReportMensileSuperpartner(data) {
        const url = `${REND_ENDPOINT}/reportmensilesuperpartner`;
        return new Promise((resolve, reject) => {
            ApiService.postRequest(resolve, reject, url, data);
        });
    },

    /**
     * NUOVA FUNZIONE: Recupera lo storico delle rendicontazioni per il Superpartner.
     */
    getStoricoSuperpartner(data) {
        // Definiamo un nuovo endpoint per la logica del Superpartner
        const url = `${REND_ENDPOINT}/storico-superpartner`;
        return new Promise((resolve, reject) => {
            ApiService.postRequest(resolve, reject, url, data);
        });
    },

    /**
     * NUOVA FUNZIONE: Carica la fattura per la rendicontazione del Superpartner.
     */
    uploadFatturaSuperpartner(formData) {
        // Definiamo un nuovo endpoint per l'upload del Superpartner
        const url = `${REND_ENDPOINT}/upload-fattura-superpartner`;
        const token = localStorage.getItem("token");

        return new Promise((resolve, reject) => {
            fetch(url, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`
                },
                body: formData
            })
            .then(response => {
                if (response.ok) {
                    resolve(response.json());
                } else {
                    response.json().then(err => reject(err)).catch(() => reject(response));
                }
            })
            .catch(error => {
                reject(error);
            });
        });
    }
};

export default RendicontazioneService;